/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Source from './Source';
//@import com/ibm/bi/platform/moser/client/cde/Source (loadtime) // superclass

/**
 * JDBC connection data source
 * @author  nbalaba
 */
export default class DatabaseSource extends Source{

	static SCHEMA = "schema";

	static SOURCES = "sources";

	schema = null;

	sources = null;



	static fromJSON(json) {
		var source = new DatabaseSource();
		source.setAssetId(json["asset_id"].toString());
		source.setProjectId(json["project_id"].toString());
		source.setSchema(json["schema"].toString());
		source.setSources(json["sources"]);
		return source;
	}

	constructor() {
		super();
		this.sources = [];
	}

	/**
	 * @return {String}  the schema
	 */
	getSchema() {
		return this.schema;
	}

	/**
	 * @param {String} schema the schema to set
	 */
	setSchema(schema) {
		this.schema = schema;
	}

	/**
	 * @return {Array}  the sources
	 */
	getSources() {
		return this.sources;
	}

	/**
	 * @param {Array} sources the sources to set
	 */
	setSources(sources) {
		this.sources = sources;
	}

	isFile() {
		return false;
	}

	toJSON() {
		var json = super.toJSON();
		json["schema"] = this.getSchema();
		json["sources"] = this.getSources();
		return json;
	}

	isDatabase() {
		return true;
	}

	getUniqueKey() {
		return super.getUniqueKey() + ":" + this.getSchema();
	}
}


// WEBPACK FOOTER //
// ./src/generated/DatabaseSource.js